module.exports = __webpack_public_path__ + "assets/img/class-1.5cc500a9.svg";